import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapFinancialsData } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseGetCreditReviewFinancialsQueryProps = {
	creditReviewId: string;
};

const useGetCreditReviewFinancialsQuery = ({
	creditReviewId,
}: UseGetCreditReviewFinancialsQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["getExecutiveFinancialsInfo", creditReviewId],
		() =>
			creditReviewDetailsService.getFinancialsInfo({
				creditReviewId,
			}),
		{
			select: mapFinancialsData,
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!creditReviewId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetCreditReviewFinancialsQuery;
